// Корень пульта для вошедшего (задачи D4, D5): каркас D5 (сайдбар, пилюля статуса, ⌘K, шпаргалка, баннер связи,
// тосты, окно «Сессия истекла») вокруг экрана раздела.
import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { AppShell } from '@/shell/app-shell';

/**
 * Подложка и панель без каркаса: в них ошибка корня (не узнали, кто вошёл — каркасу не из чего строить меню) и
 * загрузка до первого экрана.
 */
export function WorkPanel({ children }: { readonly children: ReactNode }) {
  return (
    <div className="min-h-dvh bg-background p-2">
      <main id="main" className="min-h-[calc(100dvh-1rem)] rounded-xl border border-border bg-card">
        {children}
      </main>
    </div>
  );
}

export function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

/** Пока корневой загрузчик узнаёт, кто вошёл: пустая подложка, без мигания спиннера (ответ `me` быстрый). */
export function AppLoading() {
  return (
    <div className="min-h-dvh bg-background" aria-busy="true">
      <p className="sr-only">Пульт загружается…</p>
    </div>
  );
}
